import React from 'react'
import { useTranslation } from 'react-i18next';

import {
  TableHead,
  TableRow,
  TableCell,
  withStyles
} from '@material-ui/core'

import { CommonFonts } from '@/theme'

const TableHeader = () => {
  const { t } = useTranslation()

  const headCells = [
    {
      id: 'promotion_name',
      label: t('promotions.promotion_name'),
      width: '25%',
    },
    {
      id: 'promotion_type',
      label: t('promotions.promotion_type'),
      width: '20%',
    },
    {
      id: 'expiry_date',
      label: t('promotions.expiry_date'),
      width: '20%',
    },
    {
      id: 'status',
      label: t('promotions.status'),
      width: '20%',
    },
    {
      id: 'empty',
      label: '',
      width: '15%',
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            style={{
              width: headCell.width,
              borderBottom: 'none'
            }}
          >
            {headCell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const StyledTableCell = withStyles(() => ({
  root: {
    borderBottom: 'none',
    ...CommonFonts.darkFont14,
    fontWeight: 'normal'
  },
  head: {
    backgroundColor: '#F3F5F7',
  },
  body: {
    ...CommonFonts.darkFont14
  },
}))(TableCell);


export default TableHeader